import { FormListFieldData } from "antd";

import { IMasterUser, TLoading } from "@zustand/interface";
import { IMillDetail, IMillWatch } from "@components/Form/interface";

interface IFormMill {
  millWatch: IMillWatch[];
  field: FormListFieldData;
}

export const handleValueString = (value: string | undefined): string => {
  return value ?? "";
};

export const handleValueArray = <T>(value: T[] | null | undefined): T[] => {
  return value ?? [];
};

export const handleValueNumber = (value: number | undefined): number => {
  return value ?? 0;
};

export const getMillData = ({ millWatch, field }: IFormMill): string => {
  const millData = millWatch
    ? JSON.parse(millWatch[field.name]?.mill_data ?? "{}")
    : {};
  const { province, district, subdistrict } = millData;
  const addressMill = `${province ?? ""} ${district ?? ""} ${
    subdistrict ?? ""
  }`;

  return addressMill;
};

export const checkMillData = ({ millWatch, field }: IFormMill) => {
  return millWatch[field.name]?.mill_data && millWatch[field.name]?.mill_weight;
};

export const checkMillDisable = ({ millWatch, field }: IFormMill): boolean => {
  return !(
    millWatch?.length > 0 &&
    millWatch[field.name]?.mill_data &&
    millWatch[field.name]?.mill_weight &&
    millWatch[field.name]?.mill_weight !== "0"
  );
};

export const checkMillCPI = (user: IMasterUser, data: IMillDetail[]) => {
  const millData =
    user?.corporation_code === "cpi" ? JSON.stringify(data[0]) : undefined;
  return millData;
};

export const checkRequiredMillWeight = ({ millWatch, field }: IFormMill) => {
  const condition = field.name === 0 || millWatch[field.name]?.mill_data;
  return condition;
};

export const handleValueCondition = <Condition, True, False>(
  condition: Condition,
  valueTrue: True,
  valueFalse: False,
): True | False => {
  return condition ? valueTrue : valueFalse;
};

export const handleValueOr = <T, D>(value: T, defaultValue: D): T | D => {
  return value ?? defaultValue;
};

export const handleLoading = (
  loading: TLoading[],
  name: string,
  status: string,
) => {
  return loading.some((val) => val.name === name && val.status === status);
};

export const checkCPI = (corporation_code: string): boolean => {
  const cpi = corporation_code === "cpi";
  return cpi;
};

export const handleKeyDown = <T extends HTMLElement>(
  e: React.KeyboardEvent<T>,
  functionOther: () => void,
) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    functionOther();
  }
};

export const handleRefresh = () => {
  globalThis.location.reload();
};
